
import React, { useState, useContext } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
import { Form } from 'react-bootstrap'
import { chevronDown, chevronUp } from 'react-icons-kit/feather'
// import { ToastContainer, toast } from 'react-toastify'
// //import 'react-toastify/dist/ReactToastify.css'
import { optionContext } from '../../../utils/context/optionContext'
//toast.configure({ autoClose: 2000 })

const Interest = (props) => {
    const [show, setShow] = useState(Boolean)
    const { options } = useContext(optionContext)
    const interestsIndex = options?.settingFiled.map(function (e) { return e.label }).indexOf("Interests")
    return (
        <div className="hobby-interest">
            <div className="container">
                <div className="card shadow mb-4">
                    {
                        show ?
                            <>
                                <div className="card-header"
                                    onClick={() => setShow(!show)}
                                >
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex align-items-center"><h5 className="mb-0">Interest</h5></div>
                                        <div className="ml-auto">
                                            <button className="btn shadow"
                                            >
                                                <Icon icon={chevronUp} size={14} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <Form>
                                        {options.settingFiled[interestsIndex].value.map((item, i) =>
                                            <div key={i} className="mb-3 singleHobby d-inline-flex">
                                                <Form.Check
                                                    custom
                                                    type="checkbox"
                                                    label={item}
                                                    id={item}
                                                    value={item}
                                                    checked={props.interests.includes(item)}
                                                    onChange={(e) => props.pushToInterest(item, e.target.checked)}
                                                />
                                            </div>
                                        )}
                                    </Form>
                                </div>
                            </>
                            :
                            <div className="card-header"
                                onClick={() => setShow(!show)}
                            >
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center"><h5 className="mb-0">Interest</h5></div>
                                    <div className="ml-auto">
                                        <button className="btn shadow"
                                        >
                                            <Icon icon={chevronDown} size={14} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                    }
                </div>
            </div>
        </div>

    );
};

export default Interest;